import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '../../../domain/models/user/user';
import { TranslatePipe } from '@ngx-translate/core';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'app-user-status-modal',
  standalone: true,
  imports: [TranslatePipe, LowerCasePipe],
  templateUrl: './user-status-modal.component.html',
  styleUrl: './user-status-modal.component.scss',
})
export class UserStatusModalComponent {
  @Input() user!: User;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  get actionLabel(): string {
    return this.user.isActive ? 'Disable' : 'Enable';
  }

  get actionKey(): string {
    return this.user.isActive ? 'admin.users.disable' : 'admin.users.enable';
  }
}
